// src/layouts/ProtectedShell.tsx
import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect, useRef, Suspense } from "react";
import Sidebar from "../../components/Sidebar";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function ProtectedShell() {
  const [isOpen, setIsOpen] = useState(true)
  const location = useLocation()

  const hideSidebar =
    location.pathname.startsWith('/exportacao') ||
    location.pathname.startsWith('/planner') ||
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/planilha-processos') ||
    location.pathname.startsWith('/purchase-orders/planilha') ||
    location.pathname.startsWith('/access-denied')

  // Pós-Registro é uma tabela larga: entra com o sidebar recolhido e, ao sair,
  // volta ao estado de antes. O usuário pode reabrir manualmente lá dentro.
  const isPosRegistro = location.pathname.startsWith("/pos-registro");
  const isOpenRef = useRef(isOpen);
  isOpenRef.current = isOpen;
  const isOpenAntesDoPosRegistro = useRef<boolean | null>(null);
  useEffect(() => {
    if (isPosRegistro) {
      isOpenAntesDoPosRegistro.current = isOpenRef.current;
      setIsOpen(false);
    } else if (isOpenAntesDoPosRegistro.current !== null) {
      setIsOpen(isOpenAntesDoPosRegistro.current);
      isOpenAntesDoPosRegistro.current = null;
    }
  }, [isPosRegistro]);

  return (
    <div className="flex min-h-screen overflow-x-hidden">
      {!hideSidebar && (
        <Sidebar isOpen={isOpen} onToggle={() => setIsOpen((v) => !v)} />
      )}

      <main className="min-w-0 flex-1">
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}
